import { Navigate, Routes, Route } from "react-router-dom";
import ADMIN_PATHS from "./ADMIN_PATHS";
import React from 'react';

// Layouts
import AdminLayout from "./adminLayout/AdminLayout";

// Pages
import Dashboard from "./site/Dashboard";
import About from "./site/About";
import AdminList from "./admin/AdminList";
import AdminView from './admin/AdminView.jsx';
import ProjectForm from "./site/ProjectForm";

// Product Pages
// import AliExpressViewer from "../products/AliExpressViewer";
// import AliExpressEdit from "../products/AliExpressEdit";
// import AliExpressProductForm from "../products/AliExpressProductForm";
// import ProductListPage from "../products/ProductListPage";
// import EditProduct from "../products/EditProduct";
import EditProduct from "./products/edit/EditProduct";
import ImportProductPage from "./products/import/ImportProductPage";

// Auth Pages
import LoginPage from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import BackupRestorePage from "./backupRestore/BackupRestorePage";
import FileMediaManager from "./fileMedia/FileMediaManager";
import MarketingContentPage from "./marketingContent/MarketingContentPage";
import AliExpressApiSys from "./aliExpressIntegration/AliExpressApiSys";
import ProductManagement from "./products/ProductManagement";
import CategorizedProducts from "./products/CategorizedProducts";
import B2CRouter from "./B2CManagement/B2CRouter";
import D2CManagement from "./D2CManagement/D2CManagement";
import PricingAndProfitManagement from "./PricingAndProfitManagement/PricingAndProfitManagement";
import ProductLayout from "./adminLayout/product/ProductLayout";
import ProductListPage from "./products/list/ProductListPage";
import AliExpressAdd from "./products/create/AliExpressAdd";
import ManualCreatePage from "./products/create/ManualCreatePage";
import AliExpressEdit from "./products/edit/AliExpressEdit";
import OrderManagementMenu from "./order/OrderManagementMenu";
import OrderLayout from "./adminLayout/order/OrderLayout";
import RoleLayout from "./adminLayout/role/RoleLayout";
import UserDashboard from "./workUpdate/UserDeshboard";
import UserList from "./users/UserList";
import DisputeManagement from "./dispute/DisputeManagement";
import Page404 from "./site/Page404";
import AllOrders from './order/AllOrders';
import OrderDetails from './order/OrderDetails';
import OrderDetailsPage from './order/OrderDetailsPage';
import ManualOrder from './order/ManualOrder';
import AliExpressForwarding from './order/AliExpressForwarding';
import FailedOrders from './order/FailedOrders';
import Refunds from './order/Refunds';
import StatusLogs from './order/StatusLogs';
import UserLayout from './users/UserLayout';
import CreateUser from './users/CreateUser';
import UserDetails from './users/UserDetails';
import RolesPermissions from './users/RolesPermissions';
import AdminUsers from './admin/AdminUsers';
import SecuritySettings from './admin/SecuritySettings';
import ActivityLogs from './admin/ActivityLogs';
import CreateAdmin from './admin/CreateAdmin';
import CourierIntegrationLogs from "./shipping/CourierIntegrationLogs.jsx";
import PaymentGatewayManagement from "./payment/PaymentGatewayManagement.jsx";
import FinanceManagement from "./finance/FinanceManagement.jsx";
import CampaignsDiscounts from "./campaigns/CampaignsDiscounts";
import AnalyticsReports from "./analytics/AnalyticsReports";
import ProductViewPage from "./products/list/ProductViewPage";
import CustomerManagement from "./B2CManagement/CustomerManagement";
import OrderManagement from "./B2CManagement/OrderManagement";
import WishlistManagement from "./B2CManagement/WishlistManagement";
import ReviewsManagement from "./B2CManagement/ReviewsManagement";
import PricingManagement from "./B2CManagement/PricingManagement";
import CouponsManagement from "./B2CManagement/CouponsManagement";
import LoyaltyManagement from "./B2CManagement/LoyaltyManagement";
import CategoryManagement from "./category/CategoryManagement.jsx";
import TermsManager from "./site/TermsManager.jsx";
import StoreManagement from "./partnerManagement/StoreManagement.jsx";
import PartnerProduct from "./partnerManagement/PartnerProduct.jsx";
import PartnerApplicationManagement from "./partnerManagement/PartnerApplicationManagement.jsx";
import PartnerList from "./partnerManagement/PartnerList.jsx";
import NotificationsPage from "./notification/NotificationsPage.jsx";
import MailManagementLayout from "./mail/MailManagementLayout";
import EmailSettings from "./mail/EmailSettings";
import EmailTemplates from "./mail/EmailTemplates";
import EmailLogs from "./mail/EmailLogs";
import TestMail from "./mail/TestMail";
import EmailTemplateDetail from "./mail/EmailTemplateDetail";
import CountryCurrencyManagement from "./countryCurrency/CountryCurrencyManagement";
import { SeoMetaGlobal } from "./seoMeta";
import VoucherManagement from "./voucher/VoucherManagement";
import PushNotificationPage from "./application/PushNotificationPage.jsx";

export const adminRoutes = [
 {
  path: "/",
  element: <h1>This is the admin page. </h1>,

 },
  {
    path: "/administrator",
    element: <AdminLayout />,
    children: [
      { path: "dashboard", element: <Dashboard /> },
      { path: "about", element: <About /> },
      { path: "workupdate", element: <UserDashboard /> },
      { path: "settings", element: <ProjectForm /> },
      { path: "settings/terms-management", element: <TermsManager /> },
      { path: "category", element: <CategoryManagement /> },
      {
        path: "admin",
        element: <RoleLayout />,
        children: [
          { path: "", element: <AdminList /> },
          { path: "view/:id", element: <AdminView /> },
          { path: "users", element: <AdminUsers /> },
          { path: "roles", element: <RolesPermissions /> },
          { path: "security", element: <SecuritySettings /> },
          { path: "activity", element: <ActivityLogs /> },
          { path: "create", element: <CreateAdmin /> },
        ],
      },
      {
        path: "users",
        element: <UserLayout />,
        children: [
          { path: "", element: <UserList /> },
          { path: "create", element: <CreateUser /> },
          { path: "details", element: <UserDetails /> },
          { path: "roles", element: <RolesPermissions /> },
        ],
      },
      { path: "backup", element: <BackupRestorePage /> },
      { path: "media", element: <FileMediaManager /> },
      { path: "marketing", element: <MarketingContentPage /> },
      { path: "aliexpress", element: <AliExpressApiSys /> },
      { path: "partner-stores", element: <StoreManagement /> },
      { path: "partner-list", element: <PartnerList /> },
      { path: "partner-products", element: <PartnerProduct /> },
      { path: "partner-applications", element: <PartnerApplicationManagement /> },
      { path: "b2c", element: <B2CRouter />, children: [
        { path: "customers", element: <CustomerManagement /> },
        { path: "orders", element: <OrderManagement /> },
        { path: "wishlist", element: <WishlistManagement /> },
        { path: "reviews", element: <ReviewsManagement /> },
        { path: "pricing", element: <PricingManagement /> },
        { path: "coupons", element: <CouponsManagement /> },
        { path: "loyalty", element: <LoyaltyManagement /> },
      ] },
      { path: "d2c", element: <D2CManagement /> },
      { path: "finance-management", element: <FinanceManagement /> },
      { path: "pricing", element: <PricingAndProfitManagement /> },
      { path: "support", element: <DisputeManagement /> },
      {
        path: "products",
        element: <ProductLayout />,
        children: [
          { path: "", element: <ProductManagement /> },
          { path: "addProduct", element: <ManualCreatePage /> },
          { path: "addProduct/aliexpress", element: <AliExpressAdd /> },
          { path: "editProduct/:id", element: <EditProduct /> },
          { path: "edit/aliexpress", element: <AliExpressEdit /> },
          { path: "view/:id", element: <ProductViewPage /> },
          { path: "import", element: <ImportProductPage /> },
          { path: "categorized", element: <CategorizedProducts /> },
        ],
      },
      {
        path: "orders",
        element: <OrderLayout />,
        children: [
          { path: "", element: <AllOrders /> },
          { path: "details/:id", element: <OrderDetailsPage /> },
          { path: "manual", element: <ManualOrder /> },
          { path: "aliexpress", element: <AliExpressForwarding /> },
          { path: "recovery", element: <FailedOrders /> },
          { path: "refunds", element: <Refunds /> },
          { path: "status-logs", element: <StatusLogs /> },
        ],
      },
      { path: "shipping", element: <CourierIntegrationLogs /> },
      { path: "integrations/gateways", element: <PaymentGatewayManagement /> },
      { path: "payment-gateways", element: <Navigate to={ADMIN_PATHS.PAYMENT_GATEWAYS} replace /> },
      { path: "campaigns", element: <CampaignsDiscounts /> },
      { path: "analytics", element: <AnalyticsReports /> },
      { path: "seo-meta", element: <SeoMetaGlobal /> },
      { path: "country-currency", element: <CountryCurrencyManagement /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "application/push-notification", element: <PushNotificationPage /> },
      {
        path: "mail-management",
        element: <MailManagementLayout />,
        children: [
          { path: "templates", element: <EmailTemplates /> },
          { path: "templates/new", element: <EmailTemplateDetail /> },
          { path: "templates/:key", element: <EmailTemplateDetail /> },
          { path: "logs", element: <EmailLogs /> },
          { path: "test", element: <TestMail /> },
          { path: "settings", element: <EmailSettings /> },
          { path: "", element: <Navigate to="logs" replace /> },
        ],
      },
      { path: "mail-settings", element: <Navigate to="/administrator/mail-management/settings" replace /> },
      { path: "voucher", element: <VoucherManagement /> },
      { path: "*", element: <Page404 /> },
    ],
  },
  {
    path: "/admin/auth",
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "register", element: <Navigate to="/admin/auth/login" replace /> },
      { path: "*", element: <Navigate to="/admin/auth/login" /> },
    ],
  },

];
